import React, { useEffect, useState } from 'react';
import { Typography } from '@shared/ui/typography/typography';
import { Button, Tooltip } from '@vtbhome/juicyfront';
import { AllEdit } from '@vtbhome/juicyfront/indexIcon';
import { EditProductProps } from './types';
import { Toast } from '@shared/ui/toast/toast';
import toast from 'react-hot-toast';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { useUpdateProductMutation } from '@entities/product/api/product-api';
import { CACHE_KEY_PRODUCT_UPDATE } from '@entities/product/config/api-constants';
import { ModalMutateProduct } from './modal-mutate-product/modal-mutate-product';
import { useProductFullInfoSharedQuery } from '@entities/product/libs/hooks/use-product-full-info-shared-query/use-product-full-info-shared-query';

export const EditProduct: React.FC<EditProductProps> = ({ product, onSuccess }) => {
    const [, , prefetchDetails] = useProductFullInfoSharedQuery(product.id);
    const [, editProductResult] = useUpdateProductMutation({
        fixedCacheKey: CACHE_KEY_PRODUCT_UPDATE,
    });

    const [isShowModal, setIsShowModal] = useState(false);

    const handleClose = () => {
        setIsShowModal(false);
    };

    useEffect(() => {
        if (isShowModal && editProductResult.isSuccess) {
            onSuccess?.();
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description='Данные сохранены'
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            editProductResult.reset();
        } else if (isShowModal && editProductResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Не удалось изменить продукт.\n${getQueryError(editProductResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            editProductResult.reset();
        }
    }, [isShowModal, editProductResult.isSuccess, editProductResult.isError]);

    return (
        <>
            <Tooltip position='bottom-end'>
                <Button
                    buttonType='secondary'
                    size='s'
                    startAdornment={<AllEdit size='xxs' />}
                    onClick={() => setIsShowModal(true)}
                    onMouseEnter={prefetchDetails}
                />
                <Typography size='body2_short'>Редактировать</Typography>
            </Tooltip>
            <ModalMutateProduct
                isShow={isShowModal}
                productId={product.id}
                action='edit'
                onAccept={handleClose}
                onClose={handleClose}
            />
        </>
    );
};
